export const defaultAlertInfo = {
  open: false,
  severity: "",
  message: "",
}

export const needCombinePortModels = [];

export const statusMappingDefinition = {
  green: "true",
  grey: "false",
};

export const labelMappingDefinition = {
  "true": "Active",
  "false": "Inactive",
};

export const hwVerDefinition = {
  A: {
    value: "a",
    label: "Ax"
  },
  B: {
    value: "b",
    label: "Bx",
  }
}

export const defaultActions = {
  isSave: false, // create and edit save.
  isPlay: false,
  isPause: false,
  isOpenCreateTemplate: false,
  isOpenEditModal: false,
  isOpenEditDrawer: false,
  isRemove: false,
  isRemoveConfirm: false,
}

export const defaultIsHover = {
  create: false,
}

export const defaultPortTypes = {
  "access": { label: "Access", value: "access", key: "access" },
  "trunk": { label: "Trunk", value: "trunk", key: "trunk" },
}

export const defaultRSTP = {
  "fiber": { value: "fiber", label: "Fiber" },
  "copper": { value: "copper", label: "Copper" },
}

export const defaultEnableState = {
  true: { value: "enabled", label: "Enabled" },
  false: { value: "disabled", label: "Disabled" },
}


